import { Auth } from "aws-amplify"
import _axios from "axios"
import config from "../config"
// import { useContext } from "react"
// import UserContext from "../contexts/user"
// import { Auth } from "aws-amplify"

export const axios = _axios.create({ baseURL: config.baseApiURL })

export const getHeaders = async () => {
  try {
    const session = await Auth.currentSession()
    return {
      Authorization: `Bearer ${session.getIdToken().getJwtToken()}`,
      // 'time-zone': timeZone,
    }
  } catch (err) {
    console.error(err)
  }
}

export const request = async function (options) {
  // success handler
  const onSuccess = function (response) {
    return { data: response.data }
  }

  // error handler
  const onError = function (error) {
    // const { setUser } = useContext(UserContext)
    // console.log(error.response.status)
    // if (error.response.status === 401) {
    //   Auth.signOut().then(() => {
    //     setUser(null)
    //   })
    // }
    return Promise.reject(error.response)
  }

  // adding success and error handlers to axios request
  return axios(options).then(onSuccess).catch(onError)
}
